<template>
  <div ref="container" class="w-full overflow-hidden">
    <div class="w-full flex justify-center">
      <div
        ref="inner"
        :style="{
          transform: `scale(${scale})`,
          transformOrigin: origin,
        }"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutoFitPreview',
  props: {
    minScale: {
      type: Number,
      default: 0.4,
    },
    maxScale: {
      type: Number,
      default: 1.25,
    },
    // Pixels to subtract from measured container width.
    padding: {
      type: Number,
      default: 0,
    },
    origin: {
      type: String,
      default: 'top center',
    },
  },
  data() {
    return {
      scale: 1,
      resizeObserver: null,
      rafId: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.recompute();

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.rafId) cancelAnimationFrame(this.rafId);
          this.rafId = requestAnimationFrame(() => this.recompute());
        });
        if (this.$refs.container) this.resizeObserver.observe(this.$refs.container);
      }
    });
  },
  updated() {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    this.rafId = requestAnimationFrame(() => this.recompute());
  },
  beforeUnmount() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.rafId) cancelAnimationFrame(this.rafId);
  },
  methods: {
    recompute() {
      const containerEl = this.$refs.container;
      const innerEl = this.$refs.inner;
      if (!containerEl || !innerEl) return;

      const containerWidth = containerEl.clientWidth;
      if (!containerWidth) return;

      // Measure current rendered width and infer the unscaled width.
      const currentScale = this.scale || 1;
      const measured = innerEl.getBoundingClientRect();
      const renderedWidth = measured.width;
      if (!renderedWidth) return;

      const naturalWidth = renderedWidth / currentScale;
      const available = Math.max(1, containerWidth - this.padding);
      let next = available / naturalWidth;

      // Avoid tiny rounding jitter.
      next = Math.round(next * 1000) / 1000;

      const clamped = Math.max(this.minScale, Math.min(this.maxScale, next));
      if (Number.isFinite(clamped) && Math.abs(clamped - this.scale) > 0.01) {
        this.scale = clamped;
      }
    },
  },
};
</script>
